import { render, staticRenderFns } from "./ConfigsForm.vue?vue&type=template&id=a9694bd0&scoped=true"
import script from "./ConfigsForm.vue?vue&type=script&lang=js"
export * from "./ConfigsForm.vue?vue&type=script&lang=js"
import style0 from "./ConfigsForm.vue?vue&type=style&index=0&id=a9694bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9694bd0",
  null
  
)

export default component.exports